<div class="container-wrapper">
  <div class="col-10">
    <div class="wrapper-card">
      <div class="row home-input-group d-flex searchBar">
        <input
          type="search"
          (keydown.enter)="navigateToLessonListViewSearch(scope, searchText)"
          [(ngModel)]="searchText"
          id="form1"
          class="form-control"
          placeholder="I'm looking for...."
        />
        <img
          class="searchIcon"
          src="assets/images/search.png"
          alt=""
          (click)="navigateToLessonListViewSearch(scope, searchText)"
        />
      </div>
      <mat-divider></mat-divider>
      <div class="row homeCard">
        <div
          class="row d-flex justify-content-around align-items-center homeTitleDiv"
        >
          <h2 class="homeTitle">
            <span
              >Hello
              {{ this.currentFullUserProfile.name.split(",")[1].trim() }}!</span
            >
            <div class="reviewText">
              <p>You have {{ pendingTasks }} pending actions.</p>
              @if (pendingTasks <= 0) {
              <p class="actionText" (click)="navigateToLessons()">
                Let's get started by looking at some lessons!
              </p>
              } @else {
              <p class="actionText" (click)="navigateToActions()">
                Go to your actions
              </p>
              }
            </div>
          </h2>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="row shortcutCard">
        <div class="shortcutLinks">
          <h5 class="shortcutTitle">Shortcuts:</h5>
          <div class="shortcutIcons">
            <img
              class="home_icons"
              src="assets/icons/Icon - Learning.png"
              alt="Training"
              matTooltip="Training"
              (click)="openTraining()"
            />
            <mat-divider [vertical]="true"></mat-divider>
            <img
              class="home_icons"
              src="assets/icons/feedback_icon.png"
              alt="Feedback"
              matTooltip="Feedback"
              (click)="openFeedback()"
            />
            <mat-divider [vertical]="true"></mat-divider>
            <img
              class="home_icons"
              src="assets/icons/metrics_icon.png"
              alt="View metrics"
              matTooltip="View metrics"
              (click)="navigateToMetrics()"
            />
            <mat-divider [vertical]="true"></mat-divider>
            <img
              class="home_icons"
              src="assets/icons/cvx_best-practices_icon_RGB_FA.png"
              alt="View Lesson Guidelines"
              matTooltip="View Lesson Guidelines"
              (click)="navigateToLessonGuidelines()"
            />
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="row searchCardDiv">
        <mat-card
          appearance="outlined"
          class="searchCard"
          (click)="navigateToLessonWorkflowSelection()"
        >
          <img class="icon" src="assets/icons/Icon - Document.png" alt="" />
          <mat-card-content class="createbutton">
            <h4 type="button">create new lesson</h4>
          </mat-card-content>
        </mat-card>
        <mat-card
          appearance="outlined"
          class="searchCard"
          (click)="navigateToLessonListView()"
        >
          <img class="icon" src="assets/icons/Icon - Search.png" alt="" />
          <mat-card-content class="createbutton"
            ><h4 type="button" id="createNewLesson">
              search published lessons
            </h4></mat-card-content
          >
        </mat-card>
        <mat-card
          appearance="outlined"
          class="searchCard"
          (click)="importLessons()"
        >
          <img class="icon" src="assets/icons/Icon - Bulk Import.png" alt="" />
          <mat-card-content class="createbutton"
            ><h4 type="button" id="importBulkLessons">
              import lessons in bulk
            </h4></mat-card-content
          >
        </mat-card>
        <!-- <mat-card
          class="searchCard"
          appearance="outlined"
          type="button"
          (click)="navigateToProjectLookbackView()"
        >
          <img
            class="icon"
            src="assets/images/cvx_lessons-learneds_icon_RGB_FA.png"
            alt=""
          />
          <mat-card-content class="createbutton">
            <h4 id="projectLookbackView">
              create or join a project lookback
            </h4></mat-card-content
          >
        </mat-card> -->  <!--TEMPORARILY REMOVED UNTIL PLB SUPPORTS STANDARDIZED WORKFLOW-->
      </div>
    </div>
  </div>
  <div class="top5LessonsCard wrapper-card">
    <div class="lessonsContainer">
      <div class="top-lessons-title">
        <h1>Top Lessons Learned</h1>
      </div>
      <h6 class="viewAllLessonsText" (click)="navigateToLessonListView()">
        view all lessons >
      </h6>
    </div>
    <div class="lessonDetails">
      <div style="padding-left: 40%" *ngIf="!show">
        <mat-spinner></mat-spinner>
      </div>
      <div *ngIf="show" class="toplessons">
        <app-lesson-details
          class="col-12 px-0 py-0"
          [allLessons]="topLessons"
          [lessonsSource]="currentLessonsSource"
          [showCards]="showCards"
          [compactCard]="true"
          [referenceCacheData]="commonService.referenceConfig"
          [fieldConfigCore]="fieldConfigCore"
          [selectedTabIndex]="selectedTabIndex.value"
          [showStatusLabel]="false"
        >
        </app-lesson-details>
      </div>
    </div>
  </div>
</div>
